export default __webpack_public_path__ + "static/media/howto_1.333ec784.jpg";